import React from 'react';
import {
  DocumentTextIcon,
  CloudArrowUpIcon,
  CogIcon,
  BeakerIcon,
} from '@heroicons/react/24/outline';

const instructions = [
  {
    icon: CloudArrowUpIcon,
    title: 'Upload Requirements',
    description: 'In the "Upload File" section below, upload requirements (.xlsx or .docx) file. The tool will automatically detect and extract requirements for analysis. NOTE: When uploading requirements, be sure that "Requirements" is selected under "Select File Type".'
  },
  {
    icon: CloudArrowUpIcon,
    title: '(Optional) Upload Rules',
    description: 'In the "Upload File" section below, upload rules (.xlsx) file. If no rules file is provided, the system will use default rules based on INCOSE guidelines. NOTE: When uploading rules, be sure that "Rules" is selected under "Select File Type".'
  },
  {
    icon: DocumentTextIcon,
    title: 'Select Files',
    description: 'After upload, the files will appear in the file list on the right hand side. Use the "+" button next to files to select them for processing. Choose both a requirements file (required) and a rules file (optional). If a rules file is not provided, default rules will be used'
  },
  {
    icon: CogIcon,
    title: 'Process',
    description: 'Once files are selected, click "Process Selected Files" under the file list. A control panel will appear allowing you to configure processing options such as report name. Make any desired changes'
  },
  {
    icon: BeakerIcon,
    title: 'Report Generation',
    description: 'In the control panel, click "Submit to Queue" to submit your files for processing. The system will analyze your requirements against the selected rules and generate a detailed report.'
  },
  {
    icon: BeakerIcon,
    title: 'Download Report',
    description: 'After processing is finished, the generated report (Zip containing an excel file) will appear in the "Files & Selection" portion under "Reports". A download button will be available next to the report - click this to download the report. The report will contain detailed feedback on each requirement based on the applied rules'
  }
];

function BatchProcessingGuide() {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-6">
        {instructions.map((instruction, index) => (
          <div
            key={index}
            className="group relative bg-white dark:bg-neutral-900 rounded-xl p-4 shadow-lg hover:shadow-xl transition-shadow"
          >
            {/* Step number badge */}
            <div className="absolute -top-2 -left-2 w-8 h-8 bg-gradient-to-br from-primary-500 to-secondary-500 rounded-full flex items-center justify-center shadow-lg">
              <span className="text-xs font-bold text-white">{index + 1}</span>
            </div>
            {/* Icon */}
            <div className="mb-4 inline-flex p-3 bg-gradient-to-br from-primary-100 to-secondary-100 dark:from-primary-900/30 dark:to-secondary-900/30 rounded-xl">
              <instruction.icon className="w-6 h-6 text-primary-600 dark:text-primary-400" />
            </div>
            {/* Content */}
            <h4 className="text-base font-bold text-neutral-900 dark:text-white mb-2">
              {instruction.title}
            </h4>
            <p className="text-sm text-neutral-600 dark:text-neutral-400 leading-relaxed">
              {instruction.description}
            </p>
            {/* Connector line (not on last item) */}
            {index < instructions.length - 1 && (
              <div className="hidden lg:block absolute top-1/4 -right-7 transform -translate-y-1/2">
                <svg
                  className="w-12 h-6 text-primary-400 dark:text-primary-700"
                  fill="none"
                  viewBox="0 0 60 24"
                >
                  <path
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 12 H48 M48 12 L42 6 M48 12 L42 18 M48 12 L42 18"
                  />
                </svg>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default BatchProcessingGuide;
